import environment from '@/environment'

const locationInfos = environment.getLocationsList()

export function getCountryCodeByLocation(location: string) {
  return locationInfos.find((locationInfo) => locationInfo.location === location)?.country
}
